import { Icons } from "../../../../../icons/icons";
import { getContactWhatsAppLink } from "../../../../../config/contact.config";

export default function FooterSchedule({ footerCopy }) {
  const whatsappHref = getContactWhatsAppLink(footerCopy.whatsappMode || "all");

  return (
    <div className="site-footer__col site-footer__schedule-col">
      <h4>Agendamento</h4>
      <div className="site-footer__title-line" />

      <p>{footerCopy.ctaText}</p>

      <div className="site-footer__schedule-box">
        <span>
          <Icons.MessageCircle />
          Resposta rápida
        </span>

        <span>
          <Icons.Clock />
          Horários flexíveis
        </span>

        <span>
          <Icons.User />
          Atendimento personalizado
        </span>
      </div>

      <a
        href={whatsappHref}
        target="_blank"
        rel="noreferrer"
        className="site-footer__cta"
      >
        <Icons.FaWhatsapp />
        {footerCopy.ctaButton || "Agendar no WhatsApp"}
      </a>
    </div>
  );
}